import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanClosedReasonUpdateModalUI from './LoanClosedReasonUpdateModalUI'

class LoanClosedReasonUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      //
      closingReason: this.props.loan && this.props.loan.closingReason || '',
      closingReasonError: null
    }
  }

  render() {
    return (
      <LoanClosedReasonUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        //
        closingReason={this.state.closingReason}
        onClosingReasonChange={(event) => { this.setState({ closingReason: event.target.value }) }}
        closingReasonError={this.state.closingReasonError}
        setClosingReasonError={(error) => { this.setState({ closingReasonError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/closingReason`,
      this.onSubmitCallback, {
      closingReason: this.state.closingReason
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default LoanClosedReasonUpdateModalSF